export default __webpack_public_path__ + "static/media/tensorflow.7337c0d8.png";